

/**
 * Formats price into a string with currency 1.23zl.
 * @param {string|number} price - The price to format.
 * @returns {string} The formatted price.
 */
export function formatPrice(price) {
    return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(price);
}

/**
 * Gets the quantity of items.
 * @param {Object} item - The item to extract quantity from.
 * @returns {number} The quantity of the item.
 */
export function getItemQuantity(item) {
    return item.quantity ? Number(item.quantity) : Number(item.count);
}



function calculatePrice(item, isSingle, includeSubItems) {
    let subItemsPrice = 0;
    if (includeSubItems && Array.isArray(item.subproducts)) {
        subItemsPrice = item.subproducts.reduce((acc, curVal) => {
            return acc + calculatePrice(curVal, false, false);
        }, subItemsPrice);
    }

    const quantity = isSingle ? 1 : getItemQuantity(item);
    return (parseFloat(item.price) + subItemsPrice) * quantity;
}


/**
 * Calculates the price of an item based on its quantity and subitems.
 * @param {Object} item - The item for which to calculate the price.
 * @param {Object} options - Options for price calculation.
 * @param {boolean} [options.isSingle=false] - If true, calculates the price for a single item.
 * @param {boolean} [options.includeSubItems=true] - If true, includes the price of subitems in the calculation.
 * @returns {number} The calculated price for the item.
 */
export function getItemPrice(item, options = {}) {
    const { isSingle = false, includeSubItems = true } = options;
    if (!isSingle && item.amount) {
        return item.amount;
    }

    return calculatePrice(item, isSingle, includeSubItems);
}


/**
 * Gets the formatted price for an item based on its quantity and subitems.
 * @param {Object} item - The item for which to calculate the price.
 * @param {Object} options - Options for price calculation.
 * @param {boolean} [options.isSingle=false] - If true, calculates the price for a single item.
 * @param {boolean} [options.includeSubItems=true] - If true, includes the price of subitems in the calculation.
 * @returns {number} The calculated price for the item.
 */
export function getFormattedItemPrice(item, options = {}) {
    return formatPrice(getItemPrice(item, options));
}


/**
 * Generate unique id based on id and subitems ids
 * @param {object} item
 * @returns {string} uid
 */
export function generateUniqueItemId(item) {
    return `${item.id}_${generateSubItemId(item.subproducts)}`;
}

function generateSubItemId(subItems) {
    const sortedSubItems = [...subItems].sort((a, b) => a.id - b.id);

    const subItemString = sortedSubItems.map(subItem => `${subItem.id}-${subItem.quantity}`).join('_');

    return subItemString;
}
